/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddCommentRequest } from '../model';
// @ts-ignore
import type { AssetCard } from '../model';
// @ts-ignore
import type { AssetCardExpandedDetail } from '../model';
// @ts-ignore
import type { AssetCardExpandedPaginated } from '../model';
// @ts-ignore
import type { AssetCardNature } from '../model';
// @ts-ignore
import type { AssetCardPaginated } from '../model';
// @ts-ignore
import type { AssetCardSorting } from '../model';
// @ts-ignore
import type { AssetCardStatus } from '../model';
// @ts-ignore
import type { AssetCardType } from '../model';
// @ts-ignore
import type { Comment } from '../model';
// @ts-ignore
import type { CreateAssetCardRequest } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { Log } from '../model';
// @ts-ignore
import type { RequestReviewRequest } from '../model';
// @ts-ignore
import type { Review } from '../model';
// @ts-ignore
import type { ReviewDecisionRequest } from '../model';
// @ts-ignore
import type { UpdateAssetCardAssigneeRequest } from '../model';
// @ts-ignore
import type { UpdateAssetCardRequest } from '../model';
// @ts-ignore
import type { UpdateAssetCardStatusRequest } from '../model';
// @ts-ignore
import type { UpdateReviewersRequest } from '../model';
/**
 * AssetCardsApi - axios parameter creator
 */
export const AssetCardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel all pending reviews and restore the previous status.
         * @summary Cancel Asset Card Reviews
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAssetCardReviews: async (assetCardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('cancelAssetCardReviews', 'assetCardId', assetCardId)
            const localVarPath = `/asset-cards/{asset_card_id}/reviews`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new asset card with template content, returning the slim schema (user refs as IDs).
         * @summary Create Asset Card
         * @param {CreateAssetCardRequest} createAssetCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetCard: async (createAssetCardRequest: CreateAssetCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAssetCardRequest' is not null or undefined
            assertParamExists('createAssetCard', 'createAssetCardRequest', createAssetCardRequest)
            const localVarPath = `/asset-cards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssetCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Asset Card Comments
         * @param {string} assetCardId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetCardComments: async (assetCardId: string, addCommentRequest: AddCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('createAssetCardComments', 'assetCardId', assetCardId)
            // verify required parameter 'addCommentRequest' is not null or undefined
            assertParamExists('createAssetCardComments', 'addCommentRequest', addCommentRequest)
            const localVarPath = `/asset-cards/{asset_card_id}/comments`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the asset card content as a markdown file.
         * @summary Download Asset Card
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAssetCard: async (assetCardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('downloadAssetCard', 'assetCardId', assetCardId)
            const localVarPath = `/asset-cards/{asset_card_id}/content`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single asset card with user references as IDs only.
         * @summary Get Asset Card
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCard: async (assetCardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('getAssetCard', 'assetCardId', assetCardId)
            const localVarPath = `/asset-cards/{asset_card_id}`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Asset Card Comments
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCardComments: async (assetCardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('getAssetCardComments', 'assetCardId', assetCardId)
            const localVarPath = `/asset-cards/{asset_card_id}/comments`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single asset card with the related users as nested objects.
         * @summary Get Asset Card Expanded
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCardExpanded: async (assetCardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('getAssetCardExpanded', 'assetCardId', assetCardId)
            const localVarPath = `/asset-cards/{asset_card_id}/expanded`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Asset Card Logs
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCardLogs: async (assetCardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('getAssetCardLogs', 'assetCardId', assetCardId)
            const localVarPath = `/asset-cards/{asset_card_id}/logs`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all asset cards for a project, with user references as IDs only.
         * @summary Get Asset Cards
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {AssetCardSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {AssetCardStatus | null} [status] 
         * @param {AssetCardType | null} [assetCardType] 
         * @param {AssetCardNature | null} [nature] 
         * @param {string | null} [assignedToId] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCards: async (projectId: string, page?: number, size?: number, sortBy?: AssetCardSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, status?: AssetCardStatus | null, assetCardType?: AssetCardType | null, nature?: AssetCardNature | null, assignedToId?: string | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getAssetCards', 'projectId', projectId)
            const localVarPath = `/asset-cards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (assetCardType !== undefined) {
                localVarQueryParameter['asset_card_type'] = assetCardType;
            }

            if (nature !== undefined) {
                localVarQueryParameter['nature'] = nature;
            }

            if (assignedToId !== undefined) {
                localVarQueryParameter['assigned_to_id'] = assignedToId;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all asset cards for a project, with the related users as nested objects.
         * @summary Get Asset Cards Expanded
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {AssetCardSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {AssetCardStatus | null} [status] 
         * @param {AssetCardType | null} [assetCardType] 
         * @param {AssetCardNature | null} [nature] 
         * @param {string | null} [assignedToId] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCardsExpanded: async (projectId: string, page?: number, size?: number, sortBy?: AssetCardSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, status?: AssetCardStatus | null, assetCardType?: AssetCardType | null, nature?: AssetCardNature | null, assignedToId?: string | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getAssetCardsExpanded', 'projectId', projectId)
            const localVarPath = `/asset-cards/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (assetCardType !== undefined) {
                localVarQueryParameter['asset_card_type'] = assetCardType;
            }

            if (nature !== undefined) {
                localVarQueryParameter['nature'] = nature;
            }

            if (assignedToId !== undefined) {
                localVarQueryParameter['assigned_to_id'] = assignedToId;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a status-change review for the asset card.
         * @summary Request Asset Card Review
         * @param {string} assetCardId 
         * @param {RequestReviewRequest} requestReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAssetCardReview: async (assetCardId: string, requestReviewRequest: RequestReviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('requestAssetCardReview', 'assetCardId', assetCardId)
            // verify required parameter 'requestReviewRequest' is not null or undefined
            assertParamExists('requestAssetCardReview', 'requestReviewRequest', requestReviewRequest)
            const localVarPath = `/asset-cards/{asset_card_id}/reviews`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve or reject the pending review of the asset card.
         * @summary Take Asset Card Review Decision
         * @param {string} assetCardId 
         * @param {ReviewDecisionRequest} reviewDecisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeAssetCardReviewDecision: async (assetCardId: string, reviewDecisionRequest: ReviewDecisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('takeAssetCardReviewDecision', 'assetCardId', assetCardId)
            // verify required parameter 'reviewDecisionRequest' is not null or undefined
            assertParamExists('takeAssetCardReviewDecision', 'reviewDecisionRequest', reviewDecisionRequest)
            const localVarPath = `/asset-cards/{asset_card_id}/reviews/decision`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDecisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the asset card fields provided in the request.
         * @summary Update Asset Card
         * @param {string} assetCardId 
         * @param {UpdateAssetCardRequest} updateAssetCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssetCard: async (assetCardId: string, updateAssetCardRequest: UpdateAssetCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('updateAssetCard', 'assetCardId', assetCardId)
            // verify required parameter 'updateAssetCardRequest' is not null or undefined
            assertParamExists('updateAssetCard', 'updateAssetCardRequest', updateAssetCardRequest)
            const localVarPath = `/asset-cards/{asset_card_id}`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssetCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign the asset card to a project member.
         * @summary Update Asset Card Assignee
         * @param {string} assetCardId 
         * @param {UpdateAssetCardAssigneeRequest} updateAssetCardAssigneeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssetCardAssignee: async (assetCardId: string, updateAssetCardAssigneeRequest: UpdateAssetCardAssigneeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('updateAssetCardAssignee', 'assetCardId', assetCardId)
            // verify required parameter 'updateAssetCardAssigneeRequest' is not null or undefined
            assertParamExists('updateAssetCardAssignee', 'updateAssetCardAssigneeRequest', updateAssetCardAssigneeRequest)
            const localVarPath = `/asset-cards/{asset_card_id}/assignee`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssetCardAssigneeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace the pending reviewers of the asset card.
         * @summary Update Asset Card Reviewers
         * @param {string} assetCardId 
         * @param {UpdateReviewersRequest} updateReviewersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssetCardReviewers: async (assetCardId: string, updateReviewersRequest: UpdateReviewersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('updateAssetCardReviewers', 'assetCardId', assetCardId)
            // verify required parameter 'updateReviewersRequest' is not null or undefined
            assertParamExists('updateAssetCardReviewers', 'updateReviewersRequest', updateReviewersRequest)
            const localVarPath = `/asset-cards/{asset_card_id}/reviews`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReviewersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Directly change the asset card status, bypassing the review flow.
         * @summary Update Asset Card Status
         * @param {string} assetCardId 
         * @param {UpdateAssetCardStatusRequest} updateAssetCardStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssetCardStatus: async (assetCardId: string, updateAssetCardStatusRequest: UpdateAssetCardStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCardId' is not null or undefined
            assertParamExists('updateAssetCardStatus', 'assetCardId', assetCardId)
            // verify required parameter 'updateAssetCardStatusRequest' is not null or undefined
            assertParamExists('updateAssetCardStatus', 'updateAssetCardStatusRequest', updateAssetCardStatusRequest)
            const localVarPath = `/asset-cards/{asset_card_id}/status`
                .replace('{asset_card_id}', encodeURIComponent(String(assetCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssetCardStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetCardsApi - functional programming interface
 */
export const AssetCardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetCardsApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel all pending reviews and restore the previous status.
         * @summary Cancel Asset Card Reviews
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAssetCardReviews(assetCardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAssetCardReviews(assetCardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.cancelAssetCardReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new asset card with template content, returning the slim schema (user refs as IDs).
         * @summary Create Asset Card
         * @param {CreateAssetCardRequest} createAssetCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssetCard(createAssetCardRequest: CreateAssetCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssetCard(createAssetCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.createAssetCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Asset Card Comments
         * @param {string} assetCardId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssetCardComments(assetCardId: string, addCommentRequest: AddCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssetCardComments(assetCardId, addCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.createAssetCardComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the asset card content as a markdown file.
         * @summary Download Asset Card
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAssetCard(assetCardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAssetCard(assetCardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.downloadAssetCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single asset card with user references as IDs only.
         * @summary Get Asset Card
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetCard(assetCardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetCard(assetCardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.getAssetCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Asset Card Comments
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetCardComments(assetCardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetCardComments(assetCardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.getAssetCardComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single asset card with the related users as nested objects.
         * @summary Get Asset Card Expanded
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetCardExpanded(assetCardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCardExpandedDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetCardExpanded(assetCardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.getAssetCardExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Asset Card Logs
         * @param {string} assetCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetCardLogs(assetCardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Log>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetCardLogs(assetCardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.getAssetCardLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all asset cards for a project, with user references as IDs only.
         * @summary Get Asset Cards
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {AssetCardSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {AssetCardStatus | null} [status] 
         * @param {AssetCardType | null} [assetCardType] 
         * @param {AssetCardNature | null} [nature] 
         * @param {string | null} [assignedToId] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetCards(projectId: string, page?: number, size?: number, sortBy?: AssetCardSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, status?: AssetCardStatus | null, assetCardType?: AssetCardType | null, nature?: AssetCardNature | null, assignedToId?: string | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCardPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetCards(projectId, page, size, sortBy, descending, nameOrUniqueCode, status, assetCardType, nature, assignedToId, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.getAssetCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all asset cards for a project, with the related users as nested objects.
         * @summary Get Asset Cards Expanded
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {AssetCardSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {AssetCardStatus | null} [status] 
         * @param {AssetCardType | null} [assetCardType] 
         * @param {AssetCardNature | null} [nature] 
         * @param {string | null} [assignedToId] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetCardsExpanded(projectId: string, page?: number, size?: number, sortBy?: AssetCardSorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, status?: AssetCardStatus | null, assetCardType?: AssetCardType | null, nature?: AssetCardNature | null, assignedToId?: string | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCardExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetCardsExpanded(projectId, page, size, sortBy, descending, nameOrUniqueCode, status, assetCardType, nature, assignedToId, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.getAssetCardsExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request a status-change review for the asset card.
         * @summary Request Asset Card Review
         * @param {string} assetCardId 
         * @param {RequestReviewRequest} requestReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAssetCardReview(assetCardId: string, requestReviewRequest: RequestReviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Review>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAssetCardReview(assetCardId, requestReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.requestAssetCardReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approve or reject the pending review of the asset card.
         * @summary Take Asset Card Review Decision
         * @param {string} assetCardId 
         * @param {ReviewDecisionRequest} reviewDecisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async takeAssetCardReviewDecision(assetCardId: string, reviewDecisionRequest: ReviewDecisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Review>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.takeAssetCardReviewDecision(assetCardId, reviewDecisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.takeAssetCardReviewDecision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the asset card fields provided in the request.
         * @summary Update Asset Card
         * @param {string} assetCardId 
         * @param {UpdateAssetCardRequest} updateAssetCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssetCard(assetCardId: string, updateAssetCardRequest: UpdateAssetCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssetCard(assetCardId, updateAssetCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.updateAssetCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign the asset card to a project member.
         * @summary Update Asset Card Assignee
         * @param {string} assetCardId 
         * @param {UpdateAssetCardAssigneeRequest} updateAssetCardAssigneeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssetCardAssignee(assetCardId: string, updateAssetCardAssigneeRequest: UpdateAssetCardAssigneeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssetCardAssignee(assetCardId, updateAssetCardAssigneeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.updateAssetCardAssignee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace the pending reviewers of the asset card.
         * @summary Update Asset Card Reviewers
         * @param {string} assetCardId 
         * @param {UpdateReviewersRequest} updateReviewersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssetCardReviewers(assetCardId: string, updateReviewersRequest: UpdateReviewersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Review>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssetCardReviewers(assetCardId, updateReviewersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.updateAssetCardReviewers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Directly change the asset card status, bypassing the review flow.
         * @summary Update Asset Card Status
         * @param {string} assetCardId 
         * @param {UpdateAssetCardStatusRequest} updateAssetCardStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssetCardStatus(assetCardId: string, updateAssetCardStatusRequest: UpdateAssetCardStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssetCardStatus(assetCardId, updateAssetCardStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetCardsApi.updateAssetCardStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetCardsApi - factory interface
 */
export const AssetCardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetCardsApiFp(configuration)
    return {
        /**
         * Cancel all pending reviews and restore the previous status.
         * @summary Cancel Asset Card Reviews
         * @param {AssetCardsApiCancelAssetCardReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAssetCardReviews(requestParameters: AssetCardsApiCancelAssetCardReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelAssetCardReviews(requestParameters.assetCardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new asset card with template content, returning the slim schema (user refs as IDs).
         * @summary Create Asset Card
         * @param {AssetCardsApiCreateAssetCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetCard(requestParameters: AssetCardsApiCreateAssetCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCard> {
            return localVarFp.createAssetCard(requestParameters.createAssetCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Asset Card Comments
         * @param {AssetCardsApiCreateAssetCardCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetCardComments(requestParameters: AssetCardsApiCreateAssetCardCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.createAssetCardComments(requestParameters.assetCardId, requestParameters.addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the asset card content as a markdown file.
         * @summary Download Asset Card
         * @param {AssetCardsApiDownloadAssetCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAssetCard(requestParameters: AssetCardsApiDownloadAssetCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadAssetCard(requestParameters.assetCardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single asset card with user references as IDs only.
         * @summary Get Asset Card
         * @param {AssetCardsApiGetAssetCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCard(requestParameters: AssetCardsApiGetAssetCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCard> {
            return localVarFp.getAssetCard(requestParameters.assetCardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Asset Card Comments
         * @param {AssetCardsApiGetAssetCardCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCardComments(requestParameters: AssetCardsApiGetAssetCardCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>> {
            return localVarFp.getAssetCardComments(requestParameters.assetCardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single asset card with the related users as nested objects.
         * @summary Get Asset Card Expanded
         * @param {AssetCardsApiGetAssetCardExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCardExpanded(requestParameters: AssetCardsApiGetAssetCardExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCardExpandedDetail> {
            return localVarFp.getAssetCardExpanded(requestParameters.assetCardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Asset Card Logs
         * @param {AssetCardsApiGetAssetCardLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCardLogs(requestParameters: AssetCardsApiGetAssetCardLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Log>> {
            return localVarFp.getAssetCardLogs(requestParameters.assetCardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all asset cards for a project, with user references as IDs only.
         * @summary Get Asset Cards
         * @param {AssetCardsApiGetAssetCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCards(requestParameters: AssetCardsApiGetAssetCardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCardPaginated> {
            return localVarFp.getAssetCards(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.status, requestParameters.assetCardType, requestParameters.nature, requestParameters.assignedToId, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all asset cards for a project, with the related users as nested objects.
         * @summary Get Asset Cards Expanded
         * @param {AssetCardsApiGetAssetCardsExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetCardsExpanded(requestParameters: AssetCardsApiGetAssetCardsExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCardExpandedPaginated> {
            return localVarFp.getAssetCardsExpanded(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.status, requestParameters.assetCardType, requestParameters.nature, requestParameters.assignedToId, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a status-change review for the asset card.
         * @summary Request Asset Card Review
         * @param {AssetCardsApiRequestAssetCardReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAssetCardReview(requestParameters: AssetCardsApiRequestAssetCardReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Review>> {
            return localVarFp.requestAssetCardReview(requestParameters.assetCardId, requestParameters.requestReviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve or reject the pending review of the asset card.
         * @summary Take Asset Card Review Decision
         * @param {AssetCardsApiTakeAssetCardReviewDecisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeAssetCardReviewDecision(requestParameters: AssetCardsApiTakeAssetCardReviewDecisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Review> {
            return localVarFp.takeAssetCardReviewDecision(requestParameters.assetCardId, requestParameters.reviewDecisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the asset card fields provided in the request.
         * @summary Update Asset Card
         * @param {AssetCardsApiUpdateAssetCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssetCard(requestParameters: AssetCardsApiUpdateAssetCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCard> {
            return localVarFp.updateAssetCard(requestParameters.assetCardId, requestParameters.updateAssetCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign the asset card to a project member.
         * @summary Update Asset Card Assignee
         * @param {AssetCardsApiUpdateAssetCardAssigneeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssetCardAssignee(requestParameters: AssetCardsApiUpdateAssetCardAssigneeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCard> {
            return localVarFp.updateAssetCardAssignee(requestParameters.assetCardId, requestParameters.updateAssetCardAssigneeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace the pending reviewers of the asset card.
         * @summary Update Asset Card Reviewers
         * @param {AssetCardsApiUpdateAssetCardReviewersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssetCardReviewers(requestParameters: AssetCardsApiUpdateAssetCardReviewersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Review>> {
            return localVarFp.updateAssetCardReviewers(requestParameters.assetCardId, requestParameters.updateReviewersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Directly change the asset card status, bypassing the review flow.
         * @summary Update Asset Card Status
         * @param {AssetCardsApiUpdateAssetCardStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssetCardStatus(requestParameters: AssetCardsApiUpdateAssetCardStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCard> {
            return localVarFp.updateAssetCardStatus(requestParameters.assetCardId, requestParameters.updateAssetCardStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelAssetCardReviews operation in AssetCardsApi.
 */
export interface AssetCardsApiCancelAssetCardReviewsRequest {
    readonly assetCardId: string
}

/**
 * Request parameters for createAssetCard operation in AssetCardsApi.
 */
export interface AssetCardsApiCreateAssetCardRequest {
    readonly createAssetCardRequest: CreateAssetCardRequest
}

/**
 * Request parameters for createAssetCardComments operation in AssetCardsApi.
 */
export interface AssetCardsApiCreateAssetCardCommentsRequest {
    readonly assetCardId: string

    readonly addCommentRequest: AddCommentRequest
}

/**
 * Request parameters for downloadAssetCard operation in AssetCardsApi.
 */
export interface AssetCardsApiDownloadAssetCardRequest {
    readonly assetCardId: string
}

/**
 * Request parameters for getAssetCard operation in AssetCardsApi.
 */
export interface AssetCardsApiGetAssetCardRequest {
    readonly assetCardId: string
}

/**
 * Request parameters for getAssetCardComments operation in AssetCardsApi.
 */
export interface AssetCardsApiGetAssetCardCommentsRequest {
    readonly assetCardId: string
}

/**
 * Request parameters for getAssetCardExpanded operation in AssetCardsApi.
 */
export interface AssetCardsApiGetAssetCardExpandedRequest {
    readonly assetCardId: string
}

/**
 * Request parameters for getAssetCardLogs operation in AssetCardsApi.
 */
export interface AssetCardsApiGetAssetCardLogsRequest {
    readonly assetCardId: string
}

/**
 * Request parameters for getAssetCards operation in AssetCardsApi.
 */
export interface AssetCardsApiGetAssetCardsRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: AssetCardSorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null

    readonly status?: AssetCardStatus | null

    readonly assetCardType?: AssetCardType | null

    readonly nature?: AssetCardNature | null

    readonly assignedToId?: string | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getAssetCardsExpanded operation in AssetCardsApi.
 */
export interface AssetCardsApiGetAssetCardsExpandedRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: AssetCardSorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null

    readonly status?: AssetCardStatus | null

    readonly assetCardType?: AssetCardType | null

    readonly nature?: AssetCardNature | null

    readonly assignedToId?: string | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for requestAssetCardReview operation in AssetCardsApi.
 */
export interface AssetCardsApiRequestAssetCardReviewRequest {
    readonly assetCardId: string

    readonly requestReviewRequest: RequestReviewRequest
}

/**
 * Request parameters for takeAssetCardReviewDecision operation in AssetCardsApi.
 */
export interface AssetCardsApiTakeAssetCardReviewDecisionRequest {
    readonly assetCardId: string

    readonly reviewDecisionRequest: ReviewDecisionRequest
}

/**
 * Request parameters for updateAssetCard operation in AssetCardsApi.
 */
export interface AssetCardsApiUpdateAssetCardRequest {
    readonly assetCardId: string

    readonly updateAssetCardRequest: UpdateAssetCardRequest
}

/**
 * Request parameters for updateAssetCardAssignee operation in AssetCardsApi.
 */
export interface AssetCardsApiUpdateAssetCardAssigneeRequest {
    readonly assetCardId: string

    readonly updateAssetCardAssigneeRequest: UpdateAssetCardAssigneeRequest
}

/**
 * Request parameters for updateAssetCardReviewers operation in AssetCardsApi.
 */
export interface AssetCardsApiUpdateAssetCardReviewersRequest {
    readonly assetCardId: string

    readonly updateReviewersRequest: UpdateReviewersRequest
}

/**
 * Request parameters for updateAssetCardStatus operation in AssetCardsApi.
 */
export interface AssetCardsApiUpdateAssetCardStatusRequest {
    readonly assetCardId: string

    readonly updateAssetCardStatusRequest: UpdateAssetCardStatusRequest
}

/**
 * AssetCardsApi - object-oriented interface
 */
export class AssetCardsApi extends BaseAPI {
    /**
     * Cancel all pending reviews and restore the previous status.
     * @summary Cancel Asset Card Reviews
     * @param {AssetCardsApiCancelAssetCardReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelAssetCardReviews(requestParameters: AssetCardsApiCancelAssetCardReviewsRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).cancelAssetCardReviews(requestParameters.assetCardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new asset card with template content, returning the slim schema (user refs as IDs).
     * @summary Create Asset Card
     * @param {AssetCardsApiCreateAssetCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAssetCard(requestParameters: AssetCardsApiCreateAssetCardRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).createAssetCard(requestParameters.createAssetCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Asset Card Comments
     * @param {AssetCardsApiCreateAssetCardCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAssetCardComments(requestParameters: AssetCardsApiCreateAssetCardCommentsRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).createAssetCardComments(requestParameters.assetCardId, requestParameters.addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the asset card content as a markdown file.
     * @summary Download Asset Card
     * @param {AssetCardsApiDownloadAssetCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAssetCard(requestParameters: AssetCardsApiDownloadAssetCardRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).downloadAssetCard(requestParameters.assetCardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single asset card with user references as IDs only.
     * @summary Get Asset Card
     * @param {AssetCardsApiGetAssetCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetCard(requestParameters: AssetCardsApiGetAssetCardRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).getAssetCard(requestParameters.assetCardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Asset Card Comments
     * @param {AssetCardsApiGetAssetCardCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetCardComments(requestParameters: AssetCardsApiGetAssetCardCommentsRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).getAssetCardComments(requestParameters.assetCardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single asset card with the related users as nested objects.
     * @summary Get Asset Card Expanded
     * @param {AssetCardsApiGetAssetCardExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetCardExpanded(requestParameters: AssetCardsApiGetAssetCardExpandedRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).getAssetCardExpanded(requestParameters.assetCardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Asset Card Logs
     * @param {AssetCardsApiGetAssetCardLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetCardLogs(requestParameters: AssetCardsApiGetAssetCardLogsRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).getAssetCardLogs(requestParameters.assetCardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all asset cards for a project, with user references as IDs only.
     * @summary Get Asset Cards
     * @param {AssetCardsApiGetAssetCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetCards(requestParameters: AssetCardsApiGetAssetCardsRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).getAssetCards(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.status, requestParameters.assetCardType, requestParameters.nature, requestParameters.assignedToId, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all asset cards for a project, with the related users as nested objects.
     * @summary Get Asset Cards Expanded
     * @param {AssetCardsApiGetAssetCardsExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAssetCardsExpanded(requestParameters: AssetCardsApiGetAssetCardsExpandedRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).getAssetCardsExpanded(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.status, requestParameters.assetCardType, requestParameters.nature, requestParameters.assignedToId, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request a status-change review for the asset card.
     * @summary Request Asset Card Review
     * @param {AssetCardsApiRequestAssetCardReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestAssetCardReview(requestParameters: AssetCardsApiRequestAssetCardReviewRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).requestAssetCardReview(requestParameters.assetCardId, requestParameters.requestReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve or reject the pending review of the asset card.
     * @summary Take Asset Card Review Decision
     * @param {AssetCardsApiTakeAssetCardReviewDecisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public takeAssetCardReviewDecision(requestParameters: AssetCardsApiTakeAssetCardReviewDecisionRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).takeAssetCardReviewDecision(requestParameters.assetCardId, requestParameters.reviewDecisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the asset card fields provided in the request.
     * @summary Update Asset Card
     * @param {AssetCardsApiUpdateAssetCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAssetCard(requestParameters: AssetCardsApiUpdateAssetCardRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).updateAssetCard(requestParameters.assetCardId, requestParameters.updateAssetCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign the asset card to a project member.
     * @summary Update Asset Card Assignee
     * @param {AssetCardsApiUpdateAssetCardAssigneeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAssetCardAssignee(requestParameters: AssetCardsApiUpdateAssetCardAssigneeRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).updateAssetCardAssignee(requestParameters.assetCardId, requestParameters.updateAssetCardAssigneeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace the pending reviewers of the asset card.
     * @summary Update Asset Card Reviewers
     * @param {AssetCardsApiUpdateAssetCardReviewersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAssetCardReviewers(requestParameters: AssetCardsApiUpdateAssetCardReviewersRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).updateAssetCardReviewers(requestParameters.assetCardId, requestParameters.updateReviewersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Directly change the asset card status, bypassing the review flow.
     * @summary Update Asset Card Status
     * @param {AssetCardsApiUpdateAssetCardStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAssetCardStatus(requestParameters: AssetCardsApiUpdateAssetCardStatusRequest, options?: RawAxiosRequestConfig) {
        return AssetCardsApiFp(this.configuration).updateAssetCardStatus(requestParameters.assetCardId, requestParameters.updateAssetCardStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

